export default __webpack_public_path__ + "static/media/6af9cc11c7e6d07f2a6ecb8ef638be251576697328259.1fbefda2.webp";